import urlcat from 'urlcat';

import { createClient } from '../client';

import { API_BASE_URL } from '../config';
import { CATALOGS } from '../config/endpoints';

const baseURL = urlcat(API_BASE_URL, CATALOGS);
const client = createClient(baseURL);

export default class Catalogs {
  static list(slug, { page, perPage, ...rest }) {
    const params = {
      page,
      items_per_page: perPage || 10,
      ...rest,
    };

    return client.get(`/${slug}`, { params });
  }
}
